/* eslint-disable no-unneeded-ternary */
import { createEvent, createStore } from 'effector';
export const toggleProfileModal = createEvent();
export const profileModalStore = createStore(false).on(toggleProfileModal, currentState => !currentState);
